<template>
    <ion-page>
        <top-navigation
        :back-button="true"
        back-url="/forgot-password"
        ></top-navigation>
        <ion-content :fullscreen="true" class="ion-padding">
            <div class="w-full">
                <div class="text-center mb-11 mt-5">

                    <h4 class="font-bold mb-4">Verification Code</h4>
                    <p class="text-sm text-gray-900">Verification code sent to em***@gmail.com. Enter the 6-digit verification code to reset your password.</p>
                </div>

                <otp
                />
                
            </div>
        </ion-content>
    </ion-page>
</template>

<script setup lang="ts">
import {
    IonPage,
    IonContent 
} from '@ionic/vue';
import TopNavigation from '@/partials/TopNavigation.vue';
import Otp from '@/components/forms/Otp.vue';

</script>